/**
 * Fetches and injects a product card.
 */
function createProductCard(handle) {
  const container = document.createElement('div');
  container.className = 'product-grid-item--mount';

  fetch(`/products/${encodeURIComponent(handle)}?view=card`, {
    headers: { 'X-Requested-With': 'XMLHttpRequest' }
  })
    .then(res => {
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      return res.text();
    })
    .then(html => {
      container.innerHTML = html.trim();

      // Re-initialize theme scripts if needed
      if (window.lazySizes) lazySizes.loader.unveil(container);
      if (typeof window.initGridSwatches === 'function') window.initGridSwatches(container);
      if (typeof window.initWishlist === 'function') window.initWishlist(container);

      if (window.Shopify && window.Shopify.designMode) {
        document.dispatchEvent(new Event('shopify:section:load'));
      }
    })
    .catch(err => {
      console.error('Product card fetch error:', err);
      container.innerHTML = `<p>Failed to load product: ${handle}</p>`;
    });

  return container;
}

/**
 * Renders multiple product cards into a mount point.
 */
function renderProductCards(handles, mountSelector) {
  const mount = document.querySelector(mountSelector);
  if (!mount) {
    console.warn(`Mount point not found: ${mountSelector}`);
    return;
  }
  handles.forEach(handle => {
    const card = createProductCard(handle);
    mount.appendChild(card);
  });
}

// Make globally available
window.createProductCard = createProductCard;
window.renderProductCards = renderProductCards;
